/* libs/oyan-ui/src/lib/features/admin/components/user-link-business-profile-dialog/user-link-business-profile-dialog.component.scss */
/*# sourceMappingURL=user-link-business-profile-dialog.component.css.map */
